import styled from 'styled-components'
import { font, spacing, ChevronIcon, colors } from '@chegg-ui/theme'
import { SpecialButton, SpecialOutlineButton } from '@chegg-wt/core/theme/fanta/button'
import { adjust, themeBreakPoints } from '@chegg-wt/core/theme/theme'

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`

export const Box = styled.div`
  display: flex;
  border: 1px solid ${({ theme }) => theme.Colors.forInterface.interfaceColor12};
  background-color: ${({ theme }) => theme.colors.white};
  flex-direction: column;
  justify-content: center;
  padding: 16px;
`

export const CitationStyleButton = styled(SpecialOutlineButton)`
  width: 100%;
  > span {
    font-size: ${font.size.px20};
  }
`

export const ButtonText = styled.div`
  max-width: 300px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

export const Chevron = styled(ChevronIcon)`
  margin-left: ${spacing.px4};
`

export const GroupTitle = styled.span`
  margin-left: 5px;
  margin-bottom: 8px;

  font-family: Aspira;
  font-size: 20px;
  line-height: 125%;
  font-weight: bold;

  color: ${colors.dark};
`

export const ButtonBar = styled.div`
  display: flex;
  justify-content: center;
  flex-flow: row nowrap;

  & > * {
    margin: ${spacing.px4} ${spacing.px4};
    flex-basis: 25%;
    flex-grow: 0;
  }

  @media (max-width: ${({ theme }) => adjust(themeBreakPoints.small(theme), -1)}) {
    flex-flow: row wrap;

    & > * {
      margin: ${spacing.px4} ${spacing.px4};
      flex-basis: calc(50% - 20px);
    }
  }

  @media (max-width: ${({ theme }) => adjust(themeBreakPoints.extraSmall(theme), -1)}) {
    & > * {
      margin: ${spacing.px4} 0;
      flex-basis: 100%;
    }
  }
`

export const Button = styled(SpecialButton)`
  flex-grow: 0;
  cursor: pointer;
`

export { MainWrapper } from '@chegg-wt/core/components/Layouts/styled'
